var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 11.25H9.375C8.33947 11.25 7.5 12.0895 7.5 13.125V46.875C7.5 47.9105 8.33947 48.75 9.375 48.75H50.625C51.6605 48.75 52.5 47.9105 52.5 46.875V13.125C52.5 12.0895 51.6605 11.25 50.625 11.25Z",
    stroke: "#101010",
    strokeWidth: 1.98529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 39.375L19.2991 27.5758C19.4733 27.4017 19.6799 27.2636 19.9074 27.1694C20.1349 27.0752 20.3787 27.0267 20.625 27.0267C20.8712 27.0267 21.115 27.0752 21.3425 27.1694C21.57 27.2636 21.7767 27.4017 21.9508 27.5758L32.4241 38.0492C32.5983 38.2233 32.8049 38.3614 33.0324 38.4556C33.2599 38.5499 33.5037 38.5984 33.75 38.5984C33.9962 38.5984 34.24 38.5499 34.4675 38.4556C34.695 38.3614 34.9017 38.2233 35.0758 38.0492L39.9241 33.2008C40.0983 33.0267 40.3049 32.8886 40.5324 32.7944C40.7599 32.7002 41.0037 32.6517 41.25 32.6517C41.4962 32.6517 41.74 32.7002 41.9675 32.7944C42.195 32.8886 42.4017 33.0267 42.5758 33.2008L52.5 43.125",
    stroke: "#101010",
    strokeWidth: 1.98529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 27.1875C38.6336 27.1875 40.3125 25.5086 40.3125 23.4375C40.3125 21.3664 38.6336 19.6875 36.5625 19.6875C34.4914 19.6875 32.8125 21.3664 32.8125 23.4375C32.8125 25.5086 34.4914 27.1875 36.5625 27.1875Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 1.98529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.da0eb6074df82bb0ec38b3ba7ccae083.svg";
export { ForwardRef as ReactComponent };